var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-info",class:_vm.center && 'center'},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_c('a',{staticStyle:{"font-size":"20px !important","font-weight":"600"}},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c54da8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/HeadInfo.vue
// module id = null
// module chunks = 